import { FC } from 'react';

import Table from 'modules/_shared/Table';

import HoldingClassTableHeader from './HoldingClassTableHeader';
import HoldingClassTableBody from './HoldingClassTableBody';

const HoldingClassTable: FC = () => {
  const tableContent = (
    <>
      <HoldingClassTableHeader />
      <HoldingClassTableBody />
    </>
  );

  return <Table content={tableContent} />;
};

export default HoldingClassTable;
